import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import {ApplicationState, ConnectedReduxProps} from '@reducers/index'
import {Person} from '@models/person'
import {deleteRequest, fetchRequest} from '@actions/people'
import PersonForm from "@components/people/Form";
import {createRequest, updateRequest} from '@actions/people';
import personApi from '@api/person'
import {injectIntl} from 'react-intl';


interface PropsFromState {
  loading: boolean
  data: Person[]
  errors?: string,
  count: number
}

interface PropsFromDispatch {
  createRequest: typeof createRequest
  updateRequest: typeof updateRequest
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps


class PersonFormPage extends React.Component<AllProps> {
  
  state = {
    person : null,
    person_id : this.props.match.params.id,
    is_fetched : false
  };
  
  componentDidMount(){
    if(this.state.person_id){
      this.fetchItem();
    }
  }
  
  fetchItem = () => {
    personApi.getItem({
        params: {
          id: this.state.person_id,
        }
      })
      .then(({data}) => {
        this.setState({
          person : data
        })
      })
      .catch((error) => console.log(error))
  };
  
  getContent = () => {
    if(this.state.person_id && !this.state.person){
      return null
    }
    
    return (
      <PersonForm person={this.state.person}
               intl={this.props.intl}
               listUrl={"/people"}
               history={this.props.history}
               updateRequest={this.props.updateRequest}
               createRequest={this.props.createRequest}/>
    )
  };
  
  render() {
    return (
      <Fragment>
        {this.getContent()}
      </Fragment>
    )
  }
}



const mapStateToProps = ({people}: ApplicationState) => ({
  loading: people.loading,
  errors: people.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(PersonFormPage));



